<script>
  import Types from './Types.svelte';
  import { Link, datePrettify, imgSrc } from '$client';
  export let type = 'slider';
  export let data;

  $: media = data.attributes;
  $: date = media.date ?? media.updatedAt ?? media.publishedAt ?? media.createdAt;
</script>

<li class={`blog ${media.description ? 'desc' : 'no-desc'}`} itemscope itemtype="https://schema.org/NewsArticle">
  <article>
    <Link href="/media-center/{media.url}" attributes={{ style: 'display: contents;' }}>
      <img
        loading="lazy"
        itemprop="image"
        width={media.cardImg.data.attributes.width}
        height={media.cardImg.data.attributes.height}
        src={imgSrc(media.cardImg.data.attributes.url)}
        alt={media.cardImg.data.attributes.alternativeText} />
      <Types type={media.type} />
      <meta itemprop="genre" content={media.type} />
      <svelte:element this={type === 'slider' ? 'h3' : 'h2'} itemprop="headline name">{media.header}</svelte:element>
      {#if media.description}
        <p itemprop="abstract description" title={media.description}>{media.description}</p>
      {/if}
      <time itemprop="datePublished" datetime={date}>{datePrettify('D.M.Y', date)}</time>
      <meta itemprop="author" content="uberi" />
    </Link>
  </article>
</li>

<style lang="scss">
  article {
    display: contents;
  }

  img {
    width: 100%;
    height: auto;
    border-radius: 15px;
  }

  li {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 100%;
    transition: transform 0.25s;

    &:hover {
      transform: scale(0.99);
    }

    h2,
    h3,
    :global(span),
    p,
    time {
      margin-inline: 16px;
    }

    time {
      color: rgb(44 51 60 / 100%);
      font-size: 16px;
      font-family: Roboto;
    }

    h2,
    h3 {
      color: #2c333c;
      font-weight: 600;
      font-size: 18px;
      font-family: Roboto;
    }

    @media only screen and (max-width: 1250px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;

      .desc {
        img {
          aspect-ratio: 16 / 13 !important;
        }
      }

      :global(span) {
        font-size: 14px;
      }

      h2,
      h3 {
        font-size: 16px !important;
      }

      p {
        font-size: 14px;
      }

      h2,
      h3,
      :global(span),
      p,
      time {
        margin-inline: 12px;
      }
    }

    @media only screen and (max-width: 992px) {
      p {
        font-size: 13px !important;
      }
    }

    @media only screen and (max-width: 767.98px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 5px;

      :global(span) {
        font-size: 12px;
      }

      h2,
      h3 {
        font-size: 14px !important;
      }

      p {
        font-size: 12px !important;
      }

      h2,
      h3,
      :global(span),
      p,
      time {
        margin-inline: 8px;
      }
    }

    @media only screen and (max-width: 550.98px) {
      h2,
      h3,
      :global(span),
      p,
      time {
        margin-inline: 4px;
      }
    }
  }

  .video {
    display: flex;
    grid-column-start: span 2;

    :global(span) {
      margin-bottom: 10px;
    }

    img {
      max-height: 300px;
      margin-bottom: 16px;
      object-fit: cover;
    }
  }

  .desc {
    img {
      margin-bottom: 8px;
      object-fit: cover;
      aspect-ratio: 1 / 1;
    }

    :global(span) {
      margin-bottom: 8px;
    }

    p {
      position: relative;
      display: -webkit-box;
      width: calc(100% - 32px);
      overflow: hidden;
      color: #2c333cd9;
      font-size: 16px;
      font-family: Roboto;
      line-height: 120%;
      white-space: normal;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    &:not(.video) {
      time {
        margin-top: 16px;
        padding-bottom: 15px;

        @media only screen and (max-width: 1250px) {
          margin-top: 5px;
        }
      }
    }
  }

  .no-desc:is(:not(.video)) {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    font-family: Roboto;

    &::before {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      background-color: rgb(0 0 0 / 65%);
      border-radius: 15px;
      content: '';
      pointer-events: none;
    }

    :global(span) {
      margin-bottom: 4px;
    }

    time {
      margin-bottom: 16px;
      color: #f6f7f899;
      font-size: 16px;
    }

    :global(span),
    h2,
    h3,
    time {
      z-index: 3;
      display: flex;
    }

    h2,
    h3 {
      color: #f6f7f8;
      font-weight: 600;
      font-size: 18px;
    }

    img {
      position: absolute;
      z-index: 1;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
